const Blockly = require('blockly');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const TOOLTIP = 'A collapsible menu containing other menu items.';
/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    const workspace = blocklyBlock.workspace;
    const blockId = blocklyBlock.id;

    blocklyBlock.setTooltip(TOOLTIP);
    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    line1OfInputs
        .appendField('  Icon Name:')
        .appendField(new Blockly.FieldTextInput(''), 'iconName')
        .appendField('  Title:')
        .appendField(new Blockly.FieldTextInput(), 'title');
    blocklyBlock.appendStatementInput('children').appendField('Children:', 'childrenField');
}
function convertCustomFieldsToCode(code, blocklyBlock) {
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['title', 'iconName']);
    return code;
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
